import {ThemeKeywordVo} from '../../common/shared/api/nicolas/vo/ThemeKeywordVo.interface';
import {ThemeKeyword} from '../generated/types';

export function createThemeKeyword({
  uid,
  scheme,
  title,
}: ThemeKeywordVo): ThemeKeyword {
  return {
    uid,
    scheme,
    title,
  };
}
